import React, { Component } from 'react';
import { DropdownButton, Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import PubSub from 'pubsub-js';

class Indicators extends Component {

    constructor(props) {
        super(props);
        this.state = {

        };
        this.globalIndicators = [];
        this.globalIndicators.push({ name: 'rsi', selected: true });
        this.globalIndicators.push({ name: 'macd', selected: true });
    }

    onSelectInput = (e) => {
        let indicatorName = e.target.value;
        let indicatorSelected = e.target.checked;
        let tmpIndicators = this.globalIndicators.filter(ind => ind.name !== indicatorName);
        console.log('Indicators tmpIndicators', tmpIndicators);
        if (indicatorSelected) {
            let tmpObj = { name: indicatorName, selected: indicatorSelected };
            tmpIndicators.push(tmpObj);
            this.globalIndicators.push(tmpObj);
        }
        console.log('Indicators tmpIndicators1', tmpIndicators);
        this.globalIndicators = tmpIndicators;
        console.log('Indicators', e.target.value, e, e.target.checked, e.target.name, this.globalIndicators);
        PubSub.publish('chartIndicatorsSelected', this.globalIndicators);
    }

    render() {
        return (
            <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="button-tooltip-2">Technical Indicators</Tooltip>}
            >
                <DropdownButton id="indicators" title="Indicators" size="sm">
                    <Dropdown.Item href="#/ema">
                        <input type="checkbox" ref="inputElem" autoComplete="off" name="ema" placeholder="EMA"
                            value="ema" onChange={this.onSelectInput}
                        /> EMA
                    </Dropdown.Item>
                    <Dropdown.Item href="#/sma">
                        <input type="checkbox" ref="inputElem" autoComplete="off" name="sma" placeholder="SMA"
                            value="sma" onChange={this.onSelectInput}
                        /> SMA
                    </Dropdown.Item>
                    <Dropdown.Item href="#/bb">
                        <input type="checkbox" ref="inputElem" autoComplete="off" name="bb" placeholder="Bollinger Band"
                            value="bb" onChange={this.onSelectInput}
                        /> Bollinger Band
                    </Dropdown.Item>
                    <Dropdown.Item href="#/bb">
                        <input type="checkbox" ref="inputElem" autoComplete="off" name="sar" placeholder="SAR"
                            value="sar" onChange={this.onSelectInput}
                        /> SAR
                    </Dropdown.Item>
                    
                    <Dropdown.Divider />
                    <Dropdown.Item href="#/rsi">
                        <input type="checkbox" ref="inputElem" autoComplete="off" name="rsi" placeholder="RSI"
                            value="rsi" onChange={this.onSelectInput} defaultChecked={true}
                        /> RSI
                    </Dropdown.Item>
                    <Dropdown.Item href="#/atr">
                        <input type="checkbox" ref="inputElem" autoComplete="off" name="atr" placeholder="ATR"
                            value="atr" onChange={this.onSelectInput}
                        /> ATR
                    </Dropdown.Item>
                    <Dropdown.Item href="#/macd">
                        <input type="checkbox" ref="inputElem" autoComplete="off" name="macd" placeholder="MACD"
                            value="macd" onChange={this.onSelectInput} defaultChecked={true}
                        /> MACD
                    </Dropdown.Item>
                    <Dropdown.Item href="#/bb">
                        <input type="checkbox" ref="inputElem" autoComplete="off" name="fullsto" placeholder="Full Stochastic"
                            value="fullsto" onChange={this.onSelectInput}
                        /> Full Stochastic
                    </Dropdown.Item>
                </DropdownButton>
            </OverlayTrigger>
        )
    };
}

export default Indicators;